import {
  CurrentChatGroupContext,
  CurrentChatGroupContextT,
} from "contexts/CurrentChatGroupContext";
import { useContext } from "react";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";

export const useCurrentChatGroupContext = (): CurrentChatGroupContextT => {
  if (!CurrentChatGroupContext) {
    throw new Error("Only use inside CurrentChatGroupContext");
  }

  const chatGroup = useContext(CurrentChatGroupContext);
  const currentGroup = useCurrentGroupContext();

  if (!chatGroup.uuid) {
    return { ...currentGroup, dispatch: chatGroup.dispatch };
  }

  return chatGroup;
};
